module.exports = __webpack_public_path__ + "img/icon_door.a9b77b58.svg";